import React, { Component } from 'react';
import { Row } from 'reactstrap';
import './style.scss';
import { Link } from "react-router-dom";
class ErrorPage extends Component {
    render() {
        return (
            <Row id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>Oops!</h1>
                        <h2>Network Error</h2>
                    </div>
                    <Link tag="button" className='home-button' to={`/`}>Go TO Homepage</Link>
                    {/* <a className='home-button' href="#">Go TO Homepage</a> */}
                </div>
            </Row>
        )
    }
}

export default ErrorPage